const createFingerprint = require("./fingerprint");
const createHmac = require("./hmac");

module.exports = {
  createFingerprint,
  createHmac,
};
